import Order from './order';

export default {
  Order,
};
